import React from 'react';

import { compose } from 'redux';
import { connect } from 'react-redux';
import { deleteProjectAsync } from '../../../redux/project/Actions';

import {
    Typography,
    RadioGroup,
    Radio,
    FormControlLabel,
    Select,
    MenuItem,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions
} from '@material-ui/core';

import { withStyles } from '@material-ui/core/styles';

import FolderIcon from '@material-ui/icons/Folder';
import DialogButton from '../../Common/UI/Dialog/DialogButton';
import SelectTextField from '../../Common/UI/SelectTextField';

class DeleteProjectModal extends React.Component {
    constructor(props) {
        super(props);

        this.submitDeleteProject = this.submitDeleteProject.bind(this);

        this.state = {
            selectedOption: '0',
            selectedProjectId: 0
        };
    }

    submitDeleteProject(e) {
        e.preventDefault();
        const { onClose, id, currentProject, dispatchDeleteProjectAsync } =
            this.props;
        const { selectedOption, selectedProjectId } = this.state;

        if (selectedOption === '0') {
            dispatchDeleteProjectAsync(id, selectedProjectId);
        } else {
            dispatchDeleteProjectAsync(id);
        }
        onClose();
    }

    componentDidMount() {
        const { projects, id, currentProject } = this.props;
        const selectedProject = projects.find(p => p.id === id);

        if (selectedProject.numSiteCards === 0) {
            this.setState({ selectedOption: '1' });
            return;
        }

        if (projects.length > 1) {
            this.setState({
                selectedProjectId: projects.filter(p => p.id !== id)[0].id
            });
            return;
        }
    }

    render() {
        const { open, onClose, projects, id, currentProject, classes } = this.props;
        const { selectedProjectId, selectedOption } = this.state;
        const selectedProject = projects.find(p => p.id === id);

        if (id === null) {
            return null;
        }

        return (
            <Dialog open={open} onClose={onClose} fullWidth>
                <DialogTitle disableTypography>
                    <FolderIcon />
                    <Typography variant="h4">Delete Project</Typography>
                </DialogTitle>
                <DialogContent dividers>
                    <Typography>
                        Are you sure you want to delete{' '}
                        <strong>{selectedProject.name}</strong>?
                    </Typography>
                    <RadioGroup
                        value={selectedOption}
                        onChange={e =>
                            this.setState({ selectedOption: e.target.value })
                        }>
                        <FormControlLabel
                            value="0"
                            control={<Radio />}
                            label="Move all content to another project"
                            disabled={
                                projects.length <= 1 ||
                                selectedProject.numSiteCards === 0
                            }
                        />
                        <SelectTextField
                            fullWidth
                            disabled={
                                projects.length <= 1 ||
                                selectedProject.numSiteCards === 0
                            }
                            variant="outlined"
                            value={selectedProjectId || id}>
                            {projects.map(
                                project =>
                                    project.id !== id && (
                                        <MenuItem
                                            key={project.id}
                                            onClick={() =>
                                                this.setState({
                                                    selectedProjectId: project.id
                                                })
                                            }
                                            value={project.id}>
                                            {project.name}
                                        </MenuItem>
                                    )
                            )}
                        </SelectTextField>
                        <FormControlLabel
                            value="1"
                            control={<Radio />}
                            label="Remove all content (this cannot be undone)"
                        />
                    </RadioGroup>
                </DialogContent>
                <DialogActions>
                    <DialogButton
                        className={classes.deleteButton}
                        variant="contained"
                        type="submit"
                        onClick={this.submitDeleteProject}>
                        DELETE PROJECT
                    </DialogButton>
                    <DialogButton variant="outlined" onClick={onClose}>
                        CANCEL
                    </DialogButton>
                </DialogActions>
            </Dialog>
        );
    }
}

const styles = theme => ({
    deleteButton: {
        background: theme.palette.error.main,
        color: theme.palette.text.dark
    }
});

const mapStateToProps = state => ({
    currentProject: state.project.currentProject,
    projects: state.project.projects
});

const mapDispatchToProps = dispatch => ({
    dispatchDeleteProjectAsync: (id, backupProjectId = null) =>
        dispatch(deleteProjectAsync(id, backupProjectId))
});

export default compose(
    withStyles(styles),
    connect(mapStateToProps, mapDispatchToProps)
)(DeleteProjectModal);
